/**
 *
 * "A wrapper for all modal forms with similar look"
 *
 * @file   DeckSelector.js
 * @author Lateral
 * @since  2023
 */

import * as React from 'react'
import { DeckMappDialog } from 'components/DeckMappDialog'
import { Button, Stack } from '@mui/material'

export const FormDialog = React.memo(function FormDialog_({
  modalState,
  onOpenChange,
  children,
  isLoading = false,
  hideActions = false,
  saveButtonProps = {}
}) {
  if (modalState.data) {
    modalState.originalData = modalState.data
  }

  const handleClose = (event, reason) => {
    if (reason && reason === 'backdropClick') {
      return
    }
    onOpenChange(modalState)
  }

  const onSubmit = async (data) => {
    modalState.isSave = true
    modalState.data = data

    handleClose(data)
  }

  return (
    <DeckMappDialog
      open
      title={modalState.title}
      onCancel={handleClose}
      isLoading={isLoading}
      {...(!hideActions && {
        saveButtonProps: {
          variant: 'contained',
          color: 'secondary',
          form: `form`,
          type: 'submit',
          ...saveButtonProps
        }
      })}>
      {React.cloneElement(children, { data: modalState.data, onSubmit })}

      {/* If hideActions is true, show only the Close button */}
      {hideActions && (
        <Stack direction="row" justifyContent="flex-end" spacing={2} mt={2}>
          <Button onClick={handleClose} variant="outlined" color="secondary">
            Close
          </Button>
        </Stack>
      )}
    </DeckMappDialog>
  )
})
